var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#663a93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.5H3.5A1.5 1.5 0 0 0 2 10v4a1.5 1.5 0 0 0 1.5 1.5h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15.5c.6 2.8 2.4 4.8 4.2 5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.8L17.5 4c1.2-.7 2.5.2 2.5 1.5v3.6c1 .3 1.8 1.3 1.8 2.4s-.8 2.1-1.8 2.4v3.6c0 1.3-1.3 2.2-2.5 1.5L9 15.2c-.6-.4-1-1.1-1-1.9v-2.6c0-.8.4-1.5 1-1.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicPurple);
export default __webpack_public_path__ + "static/media/mic-purple.42c6270e9342f799981ed13a047431d4.svg";
export { ForwardRef as ReactComponent };